import Logger from '/@/modules/core/app/helpers/Logger';

export const LocalOptionPlugin = {
  install(app) {
    app.mixin({
      created() {
        const { local: localOption } = this.$options;
        if (localOption && typeof localOption === 'function') {
          Object.assign(this, localOption.call(this));
        } else if (localOption) {
          Logger.log(
            'Expected option local to be only a function that returns an object',
            Logger.LEVEL_ERROR
          );
        }
      }
    });

    app.config.optionMergeStrategies.local = (toVal, fromVal) => {
      return fromVal || toVal;
    };
  }
};
